import { blockedwordConstants } from '../constants';

const initialState = {
    loading: false,
    blockedwords: [],
    error: null
};

const blockedwordReducer = (state = initialState, action) => {
    switch (action.type) {
        case blockedwordConstants.FETCH_BLOCKEDWORDS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case blockedwordConstants.FETCH_BLOCKEDWORDS_SUCCESS:
            return {
                ...state,
                loading: false,
                blockedwords: action.blockedwords,
                error: null
            };
        case blockedwordConstants.FETCH_BLOCKEDWORDS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default blockedwordReducer;
